import Currency from "../../common/Currency";
import React from "react";
import { getPriceDrop } from "../../common/utils"
import SlashedPrice from "../../common/SlashedPrice"

const RewardsPlusPricesPLP = React.memo(({product}) => {
    const original_price = product.product_details.original_price && product.has_pricedrop_tag ? getPriceDrop(product.product_variant.price, product.product_details.original_price.value) : 0;

    return (
        <div className={`rewards-plus-plp__product-price`}>
            <SlashedPrice originalPrice={original_price} currentPrice={product.price}/>
            <Currency value={parseFloat(product.price)} className="rewards-plus-plp__product-price-value" />
        </div>
    )
})

export default RewardsPlusPricesPLP;